import { Token } from '@app/core/models/auth.model';

export const SESSION_TOKEN: Token = {
  access_token: 'eyJ1c2VyX2lkIjoxfQ.X40jZg.fyFu4D-icSRcepC4TwQc-WfYdZg',
  refresh_token: 'eyJ1c2VyX2lkIjoxfQ.YXg1bQ.H6LM3aWEbpo99J5O3UVvI6-pib8',
  expires: new Date(
    new Date().setMinutes(new Date().getMinutes() + 120)
  ).getTime(),
};
